import { Switch, Redirect, Route, useHistory, useRouteMatch } from 'react-router-dom';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import React, { useContext, useEffect, useState } from 'react';

import senslaLogo from 'assets/images/sensla-logo.png';
import UserPillars from 'components/UserPillars';
import UserSurveys from 'components/UserSurveys';
import UserSidebar from 'components/UserSidebar';

import { ctx, IStore } from 'store';

import { useStyles } from './styles';

const UserDashboardHome: React.FC = () => {
  const history = useHistory();
  const match = useRouteMatch();
  const [collapsed, setCollapsed] = useState(true);
  const [toggled, setToggled] = useState(false);
  const {
    teams: { currentTeam, currentMemberId },
  } = useContext(ctx.store);
  const actions = useContext(ctx.actions);

  const classes = useStyles();

  useEffect(() => {
    if (!currentTeam) {
      const savedTeam = localStorage.getItem('team');
      if (!savedTeam) {
        history.push('/home');
      } else {
        if (!currentMemberId) {
          const parsedTeam = JSON.parse(savedTeam);
          const savedMember = localStorage.getItem('member');
          if (!savedMember) {
            setTeam(parsedTeam);
            history.push('/home');
          } else {
            const parsedMember = JSON.parse(savedMember);
            setTeam(parsedTeam, parsedMember);
          }
        }
      }
    }
  }, []);

  const setTeam = async (team: any, member?: string) => {
    if (team.teamId) {
      await ((actions.teams.getTeam(team.teamId, member) as unknown) as Promise<IStore>);
    } else {
      await ((actions.tenants.getTenant(team.tenantId, member) as unknown) as Promise<IStore>);
    }
  };

  const handleCollapsedChange = (checked: boolean) => {
    setCollapsed(checked);
  };

  const handleToggleSidebar = (value: boolean) => {
    setToggled(value);
  };

  if (!currentTeam) {
    return <div />;
  }

  return (
    <div className={classes.root}>
      <UserSidebar
        collapsed={collapsed}
        rtl={false}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
        handleCollapsedChange={handleCollapsedChange}
      />
      <Hidden smUp>
        <Grid item xs={12} md={6} className={classes.headerMobile}>
          <IconButton
            aria-label="delete"
            className={classes.toggleButton}
            size="small"
            onClick={() => handleToggleSidebar(true)}
          >
            <MenuIcon className={classes.toggleIcon} />
          </IconButton>
          <img alt="sensla logo" src={senslaLogo} className={classes.senslaLogo} />
        </Grid>
      </Hidden>
      <Container className={classes.container}>
        <Switch>
          <Route exact path={`${match.path}/pillars`}>
            <UserPillars />
          </Route>
          <Route exact path={`${match.path}/surveys`}>
            <UserSurveys />
          </Route>
          <Route path={match.path}>
            <Redirect to={`${match.path}/pillars`} />
          </Route>
        </Switch>
      </Container>
    </div>
  );
};

export { UserDashboardHome };
